module.exports = __webpack_public_path__ + "64bda6a380165e3d83d206d2d4790d0a.svg";